/**
 * 添加外部 css 文件
 * @param url
 */
export function importExternalCss(url) {
  let cssLink = document.createElement('link');
  cssLink.href = url;
  cssLink.rel = 'stylesheet';
  document.head.appendChild(cssLink);
}

/**
 * 添加外部 js 文件
 * @param url
 */
export function importExternalJs(url) {
  let jsLink = document.createElement('script');
  jsLink.src = url;
  document.body.appendChild(jsLink);
}

export const getHeight = () => {
  return window.innerHeight;
};

export const drawImageFnc = (drawObj, callback, isSignIn) => {
  if (!drawObj || !drawObj.draw) return;
  const _canvasOrg = document.createElement('canvas');
  if (!document.getElementById('imageCanvas')) {
    _canvasOrg.id = 'imageCanvas';
    _canvasOrg.style.display = 'none';
    document.body.appendChild(_canvasOrg);
  }
  const _canvas = document.getElementById('imageCanvas');
  let _canvasCt = _canvas.getContext('2d');
  _canvasCt.clearRect(0, 0, _canvas.width, _canvas.height);

  /*
   * let getPixelRatio = function (context) {
   *   let backingStore =
   *     context.backingStorePixelRatio ||
   *     context.webkitBackingStorePixelRatio ||
   *     context.mozBackingStorePixelRatio ||
   *     context.msBackingStorePixelRatio ||
   *     context.oBackingStorePixelRatio ||
   *     context.backingStorePixelRatio ||
   *     1
   *   return (window.devicePixelRatio || 1) / backingStore
   * }
   */

  // let ratio = getPixelRatio(_canvasCt)
  function drawFnc(index) {
    if (index > drawObj.draw.length - 1) {
      callback(_canvas.toDataURL('image/png'));
      return;
    }
    let _textY = 800;
    _canvasCt.beginPath();
    if (drawObj.draw[index].type === 'bg') {
      const _imgOrg = document.createElement('img');
      _imgOrg.setAttribute('crossOrigin', 'Anonymous');
      _imgOrg.src = drawObj.draw[index].content;
      _imgOrg.onload = function() {
        _canvasOrg.height = _imgOrg.height;
        _canvasOrg.width = _imgOrg.width;
        _canvasCt.drawImage(
          _imgOrg,
          0,
          0,
          drawObj.draw[index].width,
          drawObj.draw[index].height,
          drawObj.draw[index].x,
          drawObj.draw[index].y,
          drawObj.draw[index].width,
          drawObj.draw[index].height
        );
        if (isSignIn) {
          _canvasCt.fillStyle = 'rgba(0,0,0,0.5)';
          _canvasCt.fillRect(
            0,
            0,
            drawObj.draw[index].width,
            drawObj.draw[index].height
          );
        }
        drawFnc(index + 1);
      };
    } else if (drawObj.draw[index].type === 'image') {
      const _imgOrg = document.createElement('img');
      _imgOrg.setAttribute('crossOrigin', 'Anonymous');
      _imgOrg.src = drawObj.draw[index].content;

      _imgOrg.onload = function() {
        _canvasCt.drawImage(
          _imgOrg,
          0,
          0,
          _imgOrg.width,
          _imgOrg.height,
          drawObj.draw[index].x,
          drawObj.draw[index].y,
          drawObj.draw[index].width ? drawObj.draw[index].width : _imgOrg.width,
          drawObj.draw[index].height
            ? drawObj.draw[index].height
            : _imgOrg.height
        );
        drawFnc(index + 1);
      };
    } else if (drawObj.draw[index].type === 'headImg') {
      const _imgOrg = document.createElement('img');
      _imgOrg.setAttribute('crossOrigin', 'Anonymous');
      _imgOrg.src = drawObj.draw[index].content;
      _canvasCt.save(); // 先保存状态 已便于画完圆再用
      _canvasCt.beginPath(); // 开始绘制
      // 先画个圆
      _canvasCt.arc(
        drawObj.draw[index].x - drawObj.draw[index].width / 2,
        drawObj.draw[index].y - drawObj.draw[index].width / 2,
        drawObj.draw[index].width / 2,
        0,
        Math.PI * 2,
        false
      );
      _canvasCt.clip(); // 画了圆 再剪切  原始画布中剪切任意形状和尺寸。一旦剪切了某个区域，则所有之后的绘图都会被限制在被剪切的区域内

      _imgOrg.onload = function() {
        _canvasCt.drawImage(
          _imgOrg,
          0,
          0,
          _imgOrg.width,
          _imgOrg.height,
          drawObj.draw[index].x - drawObj.draw[index].width,
          drawObj.draw[index].y - drawObj.draw[index].width,
          drawObj.draw[index].width ? drawObj.draw[index].width : _imgOrg.width,
          drawObj.draw[index].height
            ? drawObj.draw[index].height
            : _imgOrg.height
        );
        _canvasCt.restore(); // 恢复之前保存的绘图上下文 恢复之前保存的绘图上下午即状态 可以继续绘制
        drawFnc(index + 1);
      };
    } else if (drawObj.draw[index].type === 'text') {
      _canvasCt.font = `${drawObj.draw[index].font}px Arial`;
      _canvasCt.fillStyle = drawObj.draw[index].color;
      _canvasCt.textAlign = drawObj.draw[index].align || 'left';
      if (
        drawObj.draw[index].content &&
        drawObj.draw[index].content.split('|').length > 1
      ) {
        const _arr = drawObj.draw[index].content.split('|');
        let temp = '';
        let row = [];

        for (let a = 0; a < _arr.length; a++) {
          if (_arr[a] !== '') {
            let _text = _arr[a].split('');

            _text.map((item, i) => {
              temp = temp + item;
              if (
                _canvasCt.measureText(temp).width >= drawObj.draw[index].width
              ) {
                row.push(temp);
                temp = '';
              } else if (i === _text.length - 1) {
                row.push(temp);
                temp = '';
              }
            });
          } else {
            row.push('');
          }
        }

        for (let b = 0; b < row.length; b++) {
          _canvasCt.beginPath();
          _canvasCt.fillText(
            row[b],
            drawObj.draw[index].x,
            Number(drawObj.draw[index].y) + (drawObj.draw[index].gap || 80) * b,
            drawObj.draw[index].width
          );
        }

        if (drawObj.draw[index].y === '800') {
          _canvasCt.fillText(
            drawObj.draw[index].content,
            drawObj.draw[index].x,
            _textY + 50
          );
        }
      } else {
        if (drawObj.draw[index].width && drawObj.draw[index].content) {
          const _arr = drawObj.draw[index].content.split('');
          let temp = '';
          let row = [];
          for (let a = 0; a < _arr.length; a++) {
            if (_canvasCt.measureText(temp).width < drawObj.draw[index].width) {
            } else {
              row.push(temp);
              temp = '';
            }
            temp = temp + _arr[a];
          }
          row.push(temp);
          console.log(row);
          for (let b = 0; b < row.length; b++) {
            _canvasCt.beginPath();
            _canvasCt.fillText(
              row[b],
              drawObj.draw[index].x,
              Number(drawObj.draw[index].y) + 80 * b
            );
            if (b === row.length - 1) {
              _textY = Number(drawObj.draw[index].y) + 80 * b;
            }
          }
        } else {
          _canvasCt.fillText(
            drawObj.draw[index].content,
            drawObj.draw[index].x,
            drawObj.draw[index].y
          );
        }
      }

      drawFnc(index + 1);
    } else if (drawObj.draw[index].type === 'rect') {
      _canvasCt.fillStyle = drawObj.draw[index].color;
      _canvasCt.fillRect(
        drawObj.draw[index].x,
        drawObj.draw[index].y,
        drawObj.draw[index].width,
        drawObj.draw[index].height
      );
      drawFnc(index + 1);
    }
  }
  drawFnc(0);
};
